import React from 'react';
import PropTypes from 'prop-types';

import { styled } from '@mui/material/styles';
import PasswordStrengthBar from 'react-password-strength-bar';
import styles from './styles';

const PasswordStrengthRaw = ({ password, className }) => (
  <div className={className}>
    <PasswordStrengthBar
      password={password}
    />
  </div>
);

PasswordStrengthRaw.propTypes = {
  password: PropTypes.string.isRequired,
  className: PropTypes.string,
};

const PasswordStrength = styled(PasswordStrengthRaw)`${styles}`;

PasswordStrength.propTypes = PasswordStrengthRaw.propTypes;

export default PasswordStrength;
